import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY as string,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN as string,
  projectId: process.env.FIREBASE_PROJECT_ID as string,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SEND_ID as string,
  appId: process.env.FIREBASE_APP_ID as string,
  measurementId: process.env.FIREBAASE_MEASUREMENT_ID as string,
};

type Config = Parameters<typeof firebase.initializeApp>[0];

export class Fuego {
  public db: ReturnType<firebase.app.App['firestore']>;
  public auth: typeof firebase.auth;
  public functions: typeof firebase.functions;
  public storage: typeof firebase.storage;
  constructor(config: Config) {
    this.db = !firebase.apps.length
      ? firebase.initializeApp(config).firestore()
      : firebase.app().firestore();
    this.db.enablePersistence({ synchronizeTabs: true }).catch(() => {});
    this.auth = firebase.auth;
    this.functions = firebase.functions;
    this.storage = firebase.storage;
  }
}

// const fire = firebase.initializeApp(firebaseConfig);
const fire = !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();

// swr firebase library ----
export const fuego = new Fuego(firebaseConfig);

// init analytics
// let analytics: firebase.analytics.Analytics;
// export async function initFirebaseAnalytics(): Promise<firebase.analytics.Analytics> {
//   if (!analytics) {
//     await require('firebase/analytics');
//     analytics = await firebase.analytics();
//   }
//   return analytics;
// }

// const analytics = firebase.analytics();

// // ----------------------------------------
// // firebase FCM START -> 얘가 있으면 모바일이 이상함
// // ----------------------------------------
// const messaging = firebase.messaging();

// // test
// Notification.requestPermission().then((permission) => {
//   if (permission === 'granted') {
//     console.log('Notification permission granted.');
//     messaging
//       .getToken({
//         vapidKey: process.env.FIREBASE_FCM_VAPIDKEY,
//       })
//       .then((currentToken) => {
//         if (currentToken) {
//           console.log({ currentToken });
//           cookieStore.setUserAlertToken(currentToken);
//         } else {
//           console.error('no fcm token');
//         }
//       });
//   } else {
//     console.error('Unable to get fcm permission to notify.');
//   }
// });

export default fire;
